import Swiper from 'swiper/bundle';

const [d] = [document];

class Blocks {
    newsslider() {
        const swiper = new Swiper('.topics-slider[data-plugin="topicsSlider"]',
            {
                slidesPerView: 'auto',
                // slidesPerView: 1,
                loop: true,
                spaceBetween: 15,
                grabCursor: true,
                pagination: {
                    el: '.topics-slider .swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.topics-slider .swiper-button-next',
                    prevEl: '.topics-slider .swiper-button-prev',
                },
                breakpoints: {
                    576: {
                        // slidesPerView: 2,
                        spaceBetween: 15,
                    },
                    768: {
                        // slidesPerView: 3,
                        spaceBetween: 46,
                    }
                },
            }
        );
    }
}

const domReady = () =>
{
    let blocks = new Blocks();
    window.addEventListener('load', () => {
        blocks.newsslider();
    });
    // console.log('トップページ内の処理');
};

export default function HOME () {
    d.addEventListener('DOMContentLoaded', domReady());
}